import { useCallback, useContext } from 'react';
import { CollapsibleContext } from '../../../../../../Collapsible.context';
export const useOnClick = () => {
    const { isOpen, toggle } = useContext(CollapsibleContext);
    const onClick = useCallback(() => {
        if (isOpen)
            toggle();
    }, [isOpen, toggle]);
    return onClick;
};
